import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues } from 'redux-form'
import { lower } from 'change-case'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, RowFields } from 'components'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { Cont } from './styled'

const GeneralInformation = (props) => {

  const { 
    username,
    valueForm,
    members, 
    memberLoading,
    // props
    isEdit = false,
    isDetail
  } = props

  React.useEffect(() => {
    props.getAllMembers(isDetail)
    // props.getHrmsMembers(isDetail)
  }, [])

  const memberOptions = members.map((m,i) => ({ key:i, value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  const pmMemberOptions = () => {
    var requesterUser = valueForm.requesterUser
    var requester = members.find(x => lower(x.username) === lower(requesterUser))
    var lv = 4
    if(requester && requester.goaLevel){
      if(Number(requester.goaLevel) > 4) lv = requester.goaLevel
    }
    return members.filter(x => Number(x.goaLevel) > lv).map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))
  }

  return (
    <StdCard title={<span className='stepTitle'>General Information</span>}>
      <Cont>
        <RowFields>
          <Field 
            name="title"
            label="Title"
            component={FieldInput}
            type={type.text}
            editable={isEdit}
            require
          />
        </RowFields>
        <RowFields>
          <Field 
            name="remark"
            label="Remark"
            component={FieldInput}
            type={type.textArea}
            editable={isEdit}
          />
        </RowFields>
        <RowFields>
          <Field 
            name="requesterUser"
            label="Requester"
            component={FieldInput}
            loading={memberLoading}
            options={memberOptions}
            type={type.select}
            editable={isEdit}
            require
          />
          <Field 
            name="projectManagerUser"
            label="Project Manager/Head BU"
            component={FieldInput}
            options={pmMemberOptions()}
            loading={memberLoading}
            type={type.select}
            editable={isEdit}
            underLabel='*Head BU ต้องเป็น Twigger/Cambium ขึ้นไป'
            require
          />
        </RowFields>
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompanyRequest')(state) || {},
    username: state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : '',
    members: state.member.members,
    memberLoading: state.member.memberLoading,
  }
}

const mapDispatchToProps = {
  getHrmsMembers,
  getAllMembers
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation)
